import Consumer from './StackNavigatorConsumer';
import Provider from './StackNavigatorProvider';
import View from './StackNavigatorView';

export default { Provider, Consumer, View };
